import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { interpolateFreeText } from 'src/i18n';
import { Construction } from 'src/models/resort/Construction';
import { UserColor } from 'src/models/resort/UserColor';
import { getConstructionTheme } from './ConstructionTheme';
import { ResortConstructionItem } from './ResortConstructionItem';

interface ResortConstructionGridItemProps {
  construction: Construction;
  userColor: UserColor;
  onClick: (construction: Construction) => void;
}

export const ResortConstructionGridItem: React.FC<ResortConstructionGridItemProps> = ({
  construction,
  userColor,
  onClick
}) => {
  const { t } = useTranslation('resort');
  const handleClick = () => onClick(construction);

  const constName = getConstructionTheme(t, construction);
  const constNameAriaLabel = interpolateFreeText(
    t,
    'aria_construction_image_01',
    'name',
    constName
  );
  return (
    <button
      className={css`
        display: block;
        width: 100%;
        padding: 0;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), color 0.2s;
        :active {
          box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
          transform: scale(0.98);
        }
      `}
      onClick={handleClick}
      aria-label={constNameAriaLabel}
    >
      <ResortConstructionItem construction={construction} userColor={userColor} />
    </button>
  );
};
